import { Form, Input } from "decorator-form";

import { EntityMultiSelect } from "common/form/fields/entitySelect/EntityMultiSelect";
import { TagSetsComponentConfig, tagSetsConfigInput } from "./components/TagSetsComponentConfig";
import TagSet from "./entities/TagSet";

const tagSetField = EntityMultiSelect.registered<TagSet, any>(TagSet, {});

@Form({title: "Refine Bundle Tag Panel Config"})
export default class RefineBundleTagConfig {

	@Input({type: tagSetField, title: "Select Tag Sets"})
	public tagSetIds?: string[];

	@Input({type: tagSetsConfigInput, title: "Tag Sets Display Settings"})
	public tagSetsConfig: TagSetsComponentConfig;

}



// WEBPACK FOOTER //
// ./src/panels/refineTag/RefineBundleTagPanelConfig.ts